// =============================================================================
// Module: Text Area Auto Size
// =============================================================================

// Notes:           Fire in bundle on a needed event. No events inside here.

import _Modules from '../core/core--modules';
import _bundle from '../core/core--bundles';
import { _g } from '../core/core--base';

const { _library } = _g;
const { _$, _utils } = _library;
const { isBrowser } = _utils;

export default new _Modules({
    name: 'Textarea Auto Height',
    settings: {
        element: false,
        elementWrapClassname: 'form-item__textarea-wrap',
        elementCloneClassname: 'form-item__textarea-clone'
    },
    fn() {
        const _module = this;
        const { settings } = _module;
        const { element, elementWrapClassname, elementCloneClassname } = settings;

        const cloneCSSProperties = [
            'lineHeight',
            'textDecoration',
            'letterSpacing',
            'fontSize',
            'fontFamily',
            'fontStyle',
            'fontWeight',
            'textTransform',
            'textAlign',
            'direction',
            'wordSpacing',
            'fontSizeAdjust',
            'whiteSpace',
            'wordWrap',
            'padding'
        ];

        const textareaCSS = {
            overflow: 'hidden',
            position: 'absolute',
            top: '0',
            left: '0',
            height: '100%',
            resize: 'none'
        };

        const preCSS = {
            display: 'block',
            visibility: 'hidden'
        };

        const containerCSS = {
            position: 'relative'
        };

        function fixFirefox($textarea) {
            // Firefox adds extra height with extra row to textarea.
            // We count on the right height to calculate the clone height, so we find what the height is and subtract it
            if (!$textarea.data('firefoxRowFixed')) {
                if ($textarea.prop('scrollHeight') > $textarea.outerHeight()) {
                    const firefoxExtraHeight = $textarea.prop('scrollHeight') - $textarea.outerHeight();
                    $textarea.next().css('padding-bottom', `${firefoxExtraHeight + 2}px`);
                    $textarea.data('firefoxRowFixed', true);
                }
            }
        }

        function resize(eventORelement) {
            const textarea = eventORelement instanceof $.Event ? eventORelement.target : eventORelement;
            fixFirefox($(textarea));
            const $textarea = $(textarea);
            // Resizes the clone element
            $textarea
                .parent()
                .find('span')
                .text(textarea.value ?? textarea.val());
        }

        const initializedDocuments = {};

        function _handleEvents(document) {
            // Only need to initialize events once per document
            if (!initializedDocuments[document]) {
                initializedDocuments[document] = true;
                // Attach only if event not present on the element
                _$.checkAndBindEvent($(document), 'input', resize, `.${elementWrapClassname} textarea`);
            }
        }

        function expandingTextarea(items) {
            return items.filter('textarea').each(function() {
                const $textarea = $(this);
                _handleEvents(this.ownerDocument || document);
                // Create Clone & run if it's not created previously, in case it's called twice
                if (!$textarea.closest(`.${elementWrapClassname}`).length) {
                    $textarea
                        .wrap(`<div class='${elementWrapClassname}'></div>`)
                        .after(`<pre class='${elementCloneClassname}'><span></span></pre>`);
                    const container = $textarea.parent().css(containerCSS);
                    const pre = container
                        .find('pre')
                        .css(preCSS)
                        .css('min-height', `${$(this).outerHeight()}px`); // Preset initial min-height
                    $textarea.css(textareaCSS);
                    $.each(cloneCSSProperties, function(i, p) {
                        pre.css(p, $textarea.css(p));
                    });
                }
            });
        }

        function resizePopulated(items) {
            return items.filter('textarea').each(function() {
                const $textarea = $(this);
                if($textarea.val()) resize($textarea);
            });
        }

        const setupTextAreas = function () {
            const $textAreas = $('textArea:enabled');
            if ($textAreas.length) {
                $.each($textAreas, function (k, v) {
                    let infoDiv = document.createElement('div'), $ele = $(v), charLimit = Number($ele.attr('data-limit') || 500), val = $ele.val(), len = val.length;
                    
                    infoDiv.classList.add('t-right');
                    infoDiv.classList.add('form-item__description');
                    infoDiv.setAttribute('data-info-for', v.name);
                    if(charLimit > 0)
                        infoDiv.innerHTML = (charLimit - len) + ' characters remaining';
                    
                    if(!$(v).next('.form-item__description').length) {
                        v.after(infoDiv);
                    }
                    let $wrapper = $ele.parents('.form-item__textarea-wrap');
                    if(!$wrapper.next('.form-item__description').length){
                        $wrapper.after(infoDiv);
                    }

                    if(charLimit > 0) {
                        $ele.on('keyup change', function () {
                            let val = $ele.val();
                            let len = val.length;
                            if (len >= charLimit) {
                                $ele.val(val.substring(0, charLimit));
                                len = charLimit;
                            }
                            $(infoDiv).text((charLimit - len) + ' characters remaining');
                        });
                    }
                });
            }
        };

        _bundle.add({
            name: 'Textarea Auto Height',
            event: ['on:BundleReady', 'on:PageUpdate', 'on:UiUpdate'],
            fn() {
                expandingTextarea($(element));
                resizePopulated($(element));
                setupTextAreas();
            }
        });
    }
});
